import {
  Button,
  Checkbox,
  Dropdown,
  Modal,
  Popconfirm,
  Select,
  Space,
  Tooltip,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CiEdit, CiLocationOn, CiSquarePlus } from "react-icons/ci";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { OneCustomer } from "../../../../Stores/Customers/OneCustomer";
import { TbEyeEdit } from "react-icons/tb";
import ViewAmmafos from "../../../Tickets/firms/Ammafos/ViewAmmafos";
import CustomerActions from "../../../../Components/Customers/CustomerActions";
import { GoCommentDiscussion } from "react-icons/go";
import { LuPenLine } from "react-icons/lu";
import {
  IoColorFillOutline,
  IoColorPaletteOutline,
  IoPersonAddOutline,
} from "react-icons/io5";
import { MdOutlineModeEditOutline, MdOutlineUnarchive } from "react-icons/md";
import axiosInstance from "../../../../Components/axiosInstance/AxiosInstance";
import AddMyTickets from "./AddMyTickets";
import formatNumberWithSpaces from "../../../../Components/NumberToWords/FormatNumber";
import { AiOutlineDelete } from "react-icons/ai";
import EditMyTickete from "./EditMyTickete";
import { PiHamburger } from "react-icons/pi";

export default function MyTickets() {
  const { data, loading, error, fetchData, putColorMYTICKET } = OneCustomer();
  let navigate = useNavigate();
  let [editModalOpen, setEditModalOpen] = useState(false);
  let [aktId, setAktId] = useState(null);
  let [open, setOpen] = useState(false);
  let [colorModalOpen, setColorModalOpen] = useState(false);
  let [colorTicket, setColorTicket] = useState(null);
  let [colorsFilter, setColorsFilter] = useState([]);
  const { id } = useParams();
  let [filterName, setFilterName] = useState(null);
  let products = {
    // norin
    n429183: "Norin Сульфат",
    n99429183: "Norin Сульфат",
    // norin end
    // chortoq
    n428676: "Chortoq Селитра",
    n99428676: "Chortoq Селитра",
    // chortoq end
    n431205: "Namangan, Uychi",
    n99426357: "Namangan, Uychi",
    n99426352: "Namangan, Uychi",
    n426352: "Namangan, Uychi",
    n428747: "Namangan, Uychi",
    n429033: "Namangan, Uychi",
    n97504: "Namangan, Uychi",
    n429181: "Namangan, Uychi",
    n99429181: "Namangan, Uychi",
    n429228: "Namangan, Uychi",
    n430098: "Namangan, Uychi",
    n99429228: "Namangan, Uychi",
    n99430098: "Namangan, Uychi",
    n9997505: "Namangan, Uychi",
    n97180: "Namangan, Uychi",
    n429314: "Namangan, Uychi",
    n97505: "Namangan, Uychi",
    n429999: "Namangan, Uychi",
    n99429314: "Namangan, Uychi",
    n99429999: "Namangan, Uychi",
    n428794: "Namangan, Uychi",
    n9997504: "Namangan, Uychi",
    n9994749: "Namangan, Uychi",
    n94681: "Namangan, Uychi",
    n9994681: "Namangan, Uychi",
    n94749: "Namangan, Uychi",
    n94847: "Namangan, Uychi",
    n9994847: "Namangan, Uychi",
    n73021: "Namangan, Uychi",
    n9973021: "Namangan, Uychi",
    n92399: "Namangan, Uychi",
    n93007: "Namangan, Uychi",
    n9993007: "Namangan, Uychi",
    n95411: "Namangan, Uychi",
    n95406: "Namangan, Uychi",
    n95952: "Namangan, Uychi",
    n92345: "Namangan, Uychi",
    n92644: "Namangan, Uychi",
    n92650: "Namangan, Uychi",
    n9992948: "Namangan, Uychi",
    n429225: "Namangan, Uychi",
    n429170: "Namangan, Uychi",
    n429032: "Namangan, Uychi",
    //  andijon shaxrixon
    n431492: "Farg'ona, Shahrixon",
    n429225: "Farg'ona, Shahrixon",
    n429170: "Farg'ona, Shahrixon",
    n429032: "Farg'ona, Shahrixon",
    // kechgi andijon shaxrixon
    n99431492: "Farg'ona, Shahrixon- kechgi",
    n99429225: "Farg'ona, Shahrixon- kechgi",
    n99429170: "Farg'ona, Shahrixon- kechgi",
    n99429032: "Farg'ona, Shahrixon- kechgi",
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        // (event.ctrlKey || event.metaKey) &&
        event.key === "+" ||
        event.key === "="
      ) {
        event.preventDefault(); // Prevent browser zoom-in
        setOpen(!open);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  useEffect(() => {
    console.log([
      ...new Set(
        data?.akt_sverka
          ?.map((el) => el?.bgColor) // Extract bgColor
          .filter((color) => color !== null && color !== undefined) // Remove null/undefined
      ),
    ]);
    console.log("new");
  }, []);
  const colors = [
    // Stone
    [
      "#FAFAF9",
      "#F5F5F4",
      "#E7E5E4",
      "#D6D3D1",
      "#A8A29E",
      "#78716C",
      "#57534E",
      "#44403C",
      "#292524",
      "#1C1917",
      "#0C0A09",
    ],

    // Sky
    [
      "#F0F9FF",
      "#E0F2FE",
      "#BAE6FD",
      "#7DD3FC",
      "#38BDF8",
      "#0EA5E9",
      "#0284C7",
      "#0369A1",
      "#075985",
      "#0C4A6E",
      "#082F49",
    ],

    // Red
    [
      "#FEF2F2",
      "#FEE2E2",
      "#FECACA",
      "#FCA5A5",
      "#F87171",
      "#EF4444",
      "#DC2626",
      "#B91C1C",
      "#991B1B",
      "#7F1D1D",
      "#450A0A",
    ],

    // Orange
    [
      "#FFF7ED",
      "#FFEDD5",
      "#FED7AA",
      "#FDBA74",
      "#FB923C",
      "#F97316",
      "#EA580C",
      "#C2410C",
      "#9A3412",
      "#7C2D12",
      "#431407",
    ],

    // Yellow
    [
      "#FEFCE8",
      "#FEF9C3",
      "#FEF08A",
      "#FDE047",
      "#FACC15",
      "#EAB308",
      "#CA8A04",
      "#A16207",
      "#854D0E",
      "#713F12",
      "#422006",
    ],

    // Amber
    [
      "#FFFBEB",
      "#FEF3C7",
      "#FDE68A",
      "#FCD34D",
      "#FBBF24",
      "#F59E0B",
      "#D97706",
      "#B45309",
      "#92400E",
      "#78350F",
      "#451A03",
    ],

    // Green
    [
      "#F0FDF4",
      "#DCFCE7",
      "#BBF7D0",
      "#86EFAC",
      "#4ADE80",
      "#22C55E",
      "#16A34A",
      "#15803D",
      "#166534",
      "#14532D",
      "#052E16",
    ],
  ];

  const [filter, setFilter] = useState(null);

  let del = async (aktId) => {
    try {
      let { data: info } = await axiosInstance.delete(
        "/api/akt_svetka/" + aktId
      );
      console.log(info);
      if (info?.success) {
        fetchData(id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function calculateProductTotals(data) {
    const totals = {};

    data.forEach((item) => {
      const productName = item.name;
      const tonnage = item.tonna;

      if (totals[productName]) {
        totals[productName] += Number(tonnage);
      } else {
        totals[productName] = Number(tonnage);
      }
    });

    return totals;
  }

  let productsNames = () => {
    return [...new Set(data?.ykx?.map((p) => p.name))];
  };
  return (
    <div className="flex flex-col gap-2 py-2">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center justify-start gap-1">
          {[
            ...new Set(
              data?.akt_sverka
                ?.map((el) => el?.bgColor) // Extract bgColor
                .filter((color) => color !== null && color !== undefined) // Remove null/undefined
            ),
          ]?.map((el) => {
            // "Hissobdan o'tgan va yaklunlangan!"
            if (el == "#BBF7D0") {
              return (
                <Tooltip
                  sx={{ fontSize: "10px" }}
                  className="text-[14px]"
                  title={"Hissobdan o'tgan va yaklunlangan!"}
                >
                  <button
                    onClick={() => {
                      if (filter == "#BBF7D0") {
                        setFilter(null);
                        return;
                      }
                      setFilter("#BBF7D0");
                    }}
                    style={{
                      background: "#BBF7D0",
                      border: filter == "#BBF7D0" ? "2px solid #000" : "",
                    }}
                    className={
                      " w-[40px] h-[40px] text-[18px] rounded-sm  sm:rounded-md "
                    }
                  >
                    T
                  </button>
                </Tooltip>
              );
            }
            // "Hissoblanmoqda!"
            if (el == "#BAE6FD") {
              return (
                <Tooltip
                  sx={{ fontSize: "10px" }}
                  className="text-[14px]"
                  title={"Hissoblanmoqda!"}
                >
                  <button
                    onClick={() => {
                      if (filter == "#BAE6FD") {
                        setFilter(null);
                        return;
                      }
                      setFilter("#BAE6FD");
                    }}
                    style={{
                      background: "#BAE6FD",
                      border: filter == "#BAE6FD" ? "2px solid #000" : "",
                    }}
                    className={
                      " w-[40px] h-[40px] text-[18px] rounded-sm  sm:rounded-md "
                    }
                  >
                    H
                  </button>
                </Tooltip>
              );
            }
            // Atkaz bo'lgan yoki xatolik bor!
            if (el == "#FCA5A5") {
              return (
                <Tooltip
                  sx={{ fontSize: "10px" }}
                  className="text-[14px]"
                  title={"Atkaz bo'lgan yoki xatolik bor!"}
                >
                  <button
                    onClick={() => {
                      if (filter == "#FCA5A5") {
                        setFilter(null);
                        return;
                      }
                      setFilter("#FCA5A5");
                    }}
                    style={{
                      background: "#FCA5A5",
                      border: filter == "#FCA5A5" ? "2px solid #000" : "",
                    }}
                    className={
                      " w-[40px] h-[40px] text-[18px] rounded-sm  sm:rounded-md "
                    }
                  >
                    AT
                  </button>
                </Tooltip>
              );
            }

            return (
              <button
                onClick={() => {
                  if (filter == el) {
                    setFilter(null);
                    return;
                  }
                  setFilter(el);
                }}
                style={{
                  background: el,
                  border: filter == el ? "2px solid #000" : "",
                }}
                className={
                  " w-[40px] h-[40px] text-[18px] rounded-sm  sm:rounded-md flex justify-center items-center "
                }
              >
                <IoColorFillOutline />
              </button>
            );
          })}
        </div>
        <div>
          <Button
            className="flex-1 my-2"
            onClick={() => {
              //   navigate("/tickets", { replace: true });
              setOpen(true);
            }}
            variant="solid"
            icon={<CiSquarePlus className="font-[30px]" />}
          ></Button>
        </div>
      </div>
      <AddMyTickets open={open} setOpen={setOpen} />
      <EditMyTickete
        open={editModalOpen}
        setOpen={setEditModalOpen}
        data={aktId}
        setData={setAktId}
      />
      {/* #BBF7D0 */}
      <Modal
        style={{ top: "10px" }}
        title="Ranglar"
        open={colorModalOpen}
        //   loading={loadVagon}
        onOk={() => {
          setColorModalOpen(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setColorModalOpen(false);
        }}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              setColorModalOpen(false);
            }}
          >
            Saqlash
          </Button>,
        ]}
      >
        <div>
          <div className="flex flex-col items-center gap-1">
            <div className="flex flex-row items-center justify-start gap-1">
              <Tooltip
                sx={{ fontSize: "10px" }}
                className="text-[14px]"
                title={"Hissobdan o'tgan va yaklunlangan!"}
              >
                <button
                  onClick={() => {
                    putColorMYTICKET(colorTicket, "#BBF7D0", id);
                  }}
                  style={{
                    background: "#BBF7D0",
                    border: "1px solid #000",
                  }}
                  className={
                    " w-[40px] h-[40px] text-[18px] rounded-sm  sm:rounded-md "
                  }
                >
                  T
                </button>
              </Tooltip>
              <Tooltip
                sx={{ fontSize: "10px" }}
                className="text-[14px]"
                title={"Hissoblanmoqda!"}
              >
                <button
                  onClick={() => {
                    putColorMYTICKET(colorTicket, "#BAE6FD", id);
                  }}
                  style={{
                    background: "#BAE6FD",
                    border: "1px solid #000",
                  }}
                  className={
                    " w-[40px] h-[40px] text-[18px] rounded-sm  sm:rounded-md "
                  }
                >
                  H
                </button>
              </Tooltip>
              <Tooltip
                sx={{ fontSize: "10px" }}
                className="text-[14px]"
                title={"Atkaz bo'lgan yoki xatolik bor!"}
              >
                <button
                  onClick={() => {
                    putColorMYTICKET(colorTicket, "#FCA5A5", id);
                  }}
                  style={{
                    background: "#FCA5A5",
                    border: "1px solid #000",
                  }}
                  className={
                    " w-[40px] h-[40px] text-[18px] rounded-sm  sm:rounded-md "
                  }
                >
                  AT
                </button>
              </Tooltip>
              <Tooltip
                sx={{ fontSize: "10px" }}
                className="text-[14px]"
                title={"Rangni olib tashlash"}
              >
                <button
                  onClick={() => {
                    putColorMYTICKET(colorTicket, "#fff", id);
                  }}
                  style={{
                    background: "#fff",
                    border: "1px solid #000",
                  }}
                  className={
                    " w-[40px] h-[40px] text-[18px] rounded-sm  sm:rounded-md "
                  }
                >
                  AT
                </button>
              </Tooltip>
            </div>
            {colors.map((el) => {
              return (
                <div className="flex flex-row items-center gap-1">
                  {el.map((col) => (
                    <button
                      onClick={() => {
                        putColorMYTICKET(colorTicket, col, id);
                      }}
                      style={{
                        background: col,
                        border: "1px solid #000",
                      }}
                      className={
                        " w-[40px] h-[40px] rounded-sm  sm:rounded-md "
                      }
                    ></button>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </Modal>

      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
        }}
        border="1"
        className="text-[14px]"
        cellPadding="10"
      >
        <thead>
          <tr>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>

            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              {/* <select
                onChange={(e) => {
                  console.log(e.target.value);
                  setFilterName(e?.target?.value);
                }}
              >
                <option>Jami</option>
                {productsNames()?.map((el) => {
                  return <option key={el}>{el}</option>;
                })}
              </select> */}
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              {filter
                ? formatNumberWithSpaces(
                    data?.akt_sverka
                      ?.reduce((acc, curr) => {
                        if (curr?.bgColor == filter) {
                          return acc + Number(curr?.tonna);
                        }

                        return acc;
                      }, 0)
                      ?.toFixed(2)
                  )
                : formatNumberWithSpaces(
                    data?.akt_sverka
                      ?.reduce((acc, curr) => {
                        return acc + Number(curr?.tonna);
                      }, 0)
                      ?.toFixed(2)
                  )}
              Tn
            </th>
            <th
              className={`bg-[${filter}] text-[14px] text-left text-bold border border-gray-400 px-4 py-2`}
            >
              {filter
                ? formatNumberWithSpaces(
                    data?.akt_sverka
                      ?.reduce((acc, curr) => {
                        if (curr?.bgColor == filter) {
                          return acc + Number(curr?.sum);
                        }

                        return acc;
                      }, 0)
                      ?.toFixed(2)
                  )
                : formatNumberWithSpaces(
                    data?.akt_sverka
                      ?.reduce((acc, curr) => {
                        return acc + Number(curr?.sum);
                      }, 0)
                      ?.toFixed(2)
                  )}
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>
          </tr>
          <tr>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              №
            </th>

            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              Юк номи
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              Ticket
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              Соф огирлик
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              Sum
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              Sana
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              Izoh
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.akt_sverka?.map((akt, index) => {
            if (!filter) {
              return (
                <tr key={index} style={{ background: akt?.bgColor }}>
                  <td
                    // onClick={() => setEditModalOpen(true)}
                    className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1 cursor-pointer"
                  >
                    {akt?.id}
                  </td>
                  {/* <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                <Link
                  className="text-[14px]"
                  to={"/customers/" + akt?.customer_id}
                >
                  {akt?.producer}
                </Link>
              </td> */}
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    <Tooltip
                      sx={{ fontSize: "10px" }}
                      className="text-[14px]"
                      title={
                        akt?.producer +
                        " \n " +
                        akt?.name +
                        ":" +
                        calculateProductTotals(
                          data?.akt_sverka?.filter((el) => {
                            return el?.name == akt?.name;
                          })
                        )[akt?.name]?.toFixed(2)
                      }
                    >
                      {akt?.name}
                    </Tooltip>
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    {akt?.ticket}
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    {akt?.tonna} Tn
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    <Tooltip
                      sx={{ fontSize: "10px" }}
                      className="text-[14px]"
                      title={
                        "qopi :" +
                        formatNumberWithSpaces(
                          ((akt?.sum / (akt?.tonna * 1000)) * 50).toFixed(2)
                        ) +
                        "    \nKg :" +
                        formatNumberWithSpaces(
                          ((akt?.sum / (akt?.tonna * 1000)) * 50).toFixed(2) /
                            50
                        )
                      }
                    >
                      {formatNumberWithSpaces(akt?.sum)}
                    </Tooltip>
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    {moment(akt?.date).format("DD.MM.YYYY")}
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    <CustomerActions
                      actions={[
                        {
                          type: "group",
                          key: "info",
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                            >
                              <TbEyeEdit className="font-[18px]" />
                              <span className="text-[18px]">
                                {akt?.created_at?.split("T")[0]}{" "}
                                {akt?.created_at?.split("T")[1].split(".")[0]}
                              </span>
                            </div>
                          ),
                        },

                        {
                          type: "group",
                          key: "info",
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                            >
                              <IoPersonAddOutline className="font-[18px]" />{" "}
                              <span className="text-[18px]">
                                {akt?.written_by}{" "}
                              </span>
                            </div>
                          ),
                        },

                        {
                          type: "divider",
                        },
                        {
                          key: "10",
                          // disabled: akt?.is_dk,
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                              onClick={() => {
                                setColorTicket(akt?.id);
                                setColorModalOpen(true);
                                console.log(akt?.bgColor);
                              }}
                            >
                              <IoColorPaletteOutline
                                // style={{
                                //   color: "#38BDF8",
                                // }}
                                className="font-[30px]"
                              />
                              color
                              <button
                                onClick={() => {
                                  // colorSetting(col, colorYKX);
                                }}
                                style={{
                                  background: akt?.bgColor
                                    ? akt?.bgColor
                                    : "#fff",
                                }}
                                className={
                                  " w-[20px] h-[20px] rounded-sm  sm:rounded-md "
                                }
                              ></button>
                            </div>
                          ),
                        },
                        {
                          key: "6",
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                              onClick={() => {}}
                            >
                              <MdOutlineUnarchive className="font-[30px]" />
                              Arxivlash
                            </div>
                          ),
                        },
                        {
                          key: "7",
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                              onClick={() => {
                                setAktId(akt);
                                setEditModalOpen(true);
                              }}
                            >
                              <MdOutlineModeEditOutline className="font-[30px]" />
                              O'zgartirish
                            </div>
                          ),
                        },
                        {
                          key: "8",
                          label: (
                            <Popconfirm
                              title="O'chirish"
                              description={
                                `'${akt?.ticket}'` +
                                " O'chirishga ishonchingiz komilmi?"
                              }
                              onConfirm={() => {
                                del(akt?.id);
                              }}
                              // onCancel={cancel}
                              okText="Yes"
                              cancelText="No"
                            >
                              <div
                                className=" block w-[100%] flex items-center justify-start gap-2 "
                                rel="noopener noreferrer"
                              >
                                <AiOutlineDelete className="font-[30px]" />
                                O'chirish
                              </div>
                            </Popconfirm>
                          ),
                        },
                        {
                          type: "divider",
                        },
                        {
                          type: "group",
                          key: "info",
                          label: (
                            <div
                              key={akt?.ticket}
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                            >
                              <CiLocationOn className="font-[18px]" />
                              {}
                              <Tooltip
                                sx={{ fontSize: "10px" }}
                                className="text-[14px]"
                                title={
                                  products["n" + akt?.contract_no] +
                                  "  " +
                                  akt?.name
                                }
                              >
                                <span className="max-w-[200px]">
                                  {products["n" + akt?.contract_no]}
                                </span>
                              </Tooltip>
                            </div>
                          ),
                        },
                        {
                          type: "group",
                          key: "info",
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                            >
                              <GoCommentDiscussion className="font-[18px]" />
                              <Tooltip
                                sx={{ fontSize: "10px" }}
                                className="text-[14px]"
                                title={akt?.comment}
                              >
                                <span className="max-w-[200px]">
                                  {akt?.comment?.length > 5
                                    ? akt?.comment?.slice(0, 6) + "..."
                                    : akt?.comment}
                                </span>
                              </Tooltip>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </td>
                </tr>
              );
            }
            if (akt?.bgColor == filter) {
              return (
                <tr key={index} style={{ background: akt?.bgColor }}>
                  <td
                    // onClick={() => setEditModalOpen(true)}
                    className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1 cursor-pointer"
                  >
                    {akt?.id}
                  </td>
                  {/* <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                <Link
                  className="text-[14px]"
                  to={"/customers/" + akt?.customer_id}
                >
                  {akt?.producer}
                </Link>
              </td> */}
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    <Tooltip
                      sx={{ fontSize: "10px" }}
                      className="text-[14px]"
                      title={
                        akt?.producer +
                        " \n " +
                        akt?.name +
                        ":" +
                        calculateProductTotals(
                          data?.akt_sverka?.filter((el) => {
                            return el?.name == akt?.name;
                          })
                        )[akt?.name]?.toFixed(2)
                      }
                    >
                      {akt?.name}
                    </Tooltip>
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    {akt?.ticket}
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    {akt?.tonna} Tn
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    <Tooltip
                      sx={{ fontSize: "10px" }}
                      className="text-[14px]"
                      title={
                        "qopi :" +
                        formatNumberWithSpaces(
                          ((akt?.sum / (akt?.tonna * 1000)) * 50).toFixed(2)
                        ) +
                        "    \nKg :" +
                        formatNumberWithSpaces(
                          ((akt?.sum / (akt?.tonna * 1000)) * 50).toFixed(2) /
                            50
                        )
                      }
                    >
                      {formatNumberWithSpaces(akt?.sum)}
                    </Tooltip>
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    {moment(akt?.date).format("DD.MM.YYYY")}
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    <CustomerActions
                      actions={[
                        {
                          type: "group",
                          key: "info",
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                            >
                              <TbEyeEdit className="font-[18px]" />
                              <span className="text-[18px]">
                                {akt?.created_at?.split("T")[0]}{" "}
                                {akt?.created_at?.split("T")[1].split(".")[0]}
                              </span>
                            </div>
                          ),
                        },

                        {
                          type: "group",
                          key: "info",
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                            >
                              <IoPersonAddOutline className="font-[18px]" />{" "}
                              <span className="text-[18px]">
                                {akt?.written_by}{" "}
                              </span>
                            </div>
                          ),
                        },

                        {
                          type: "divider",
                        },
                        {
                          key: "10",
                          // disabled: akt?.is_dk,
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                              onClick={() => {
                                setColorTicket(akt?.id);
                                setColorModalOpen(true);
                                console.log(akt?.bgColor);
                              }}
                            >
                              <IoColorPaletteOutline
                                // style={{
                                //   color: "#38BDF8",
                                // }}
                                className="font-[30px]"
                              />
                              color
                              <button
                                onClick={() => {
                                  // colorSetting(col, colorYKX);
                                }}
                                style={{
                                  background: akt?.bgColor
                                    ? akt?.bgColor
                                    : "#fff",
                                }}
                                className={
                                  " w-[20px] h-[20px] rounded-sm  sm:rounded-md "
                                }
                              ></button>
                            </div>
                          ),
                        },
                        {
                          key: "6",
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                              onClick={() => {}}
                            >
                              <MdOutlineUnarchive className="font-[30px]" />
                              Arxivlash
                            </div>
                          ),
                        },
                        {
                          key: "7",
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                              onClick={() => {
                                setAktId(akt);
                                setEditModalOpen(true);
                              }}
                            >
                              <MdOutlineModeEditOutline className="font-[30px]" />
                              O'zgartirish
                            </div>
                          ),
                        },
                        {
                          key: "8",
                          label: (
                            <Popconfirm
                              title="O'chirish"
                              description={
                                `'${akt?.ticket}'` +
                                " O'chirishga ishonchingiz komilmi?"
                              }
                              onConfirm={() => {
                                del(akt?.id);
                              }}
                              // onCancel={cancel}
                              okText="Yes"
                              cancelText="No"
                            >
                              <div
                                className=" block w-[100%] flex items-center justify-start gap-2 "
                                rel="noopener noreferrer"
                              >
                                <AiOutlineDelete className="font-[30px]" />
                                O'chirish
                              </div>
                            </Popconfirm>
                          ),
                        },
                        {
                          type: "divider",
                        },
                        {
                          type: "group",
                          key: "info",
                          label: (
                            <div
                              key={akt?.ticket}
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                            >
                              <CiLocationOn className="font-[18px]" />
                              {}
                              <Tooltip
                                sx={{ fontSize: "10px" }}
                                className="text-[14px]"
                                title={
                                  products["n" + akt?.contract_no] +
                                  "  " +
                                  akt?.name
                                }
                              >
                                <span className="max-w-[200px]">
                                  {products["n" + akt?.contract_no]}
                                </span>
                              </Tooltip>
                            </div>
                          ),
                        },
                        {
                          type: "group",
                          key: "info",
                          label: (
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 "
                              rel="noopener noreferrer"
                            >
                              <GoCommentDiscussion className="font-[18px]" />
                              <Tooltip
                                sx={{ fontSize: "10px" }}
                                className="text-[14px]"
                                title={akt?.comment}
                              >
                                <span className="max-w-[200px]">
                                  {akt?.comment?.length > 5
                                    ? akt?.comment?.slice(0, 6) + "..."
                                    : akt?.comment}
                                </span>
                              </Tooltip>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
      {/*  NEW */}
    </div>
  );
}
